import React from "react";

import { Helmet } from "react-helmet";

import Image from "react-bootstrap/Image";
import { Row, Col, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import Nav from "react-bootstrap/Nav";


import DataConsultantsIcon from "../assets/images/icons/dataConsultants.png";
import inTheMartechIndustryIcon from "../assets/images/icons/inTheMartechIndustry.png";
import expertsIcon from "../assets/images/icons/experts.png";
import topPartnersIcon from "../assets/images/icons/topPartners.png";


import layerOne from "../assets/images/layers/GroupLeft.png";
import layerTwo from "../assets/images/layers/GroupRight.png";
import MartechSMEsIcon from "../assets/images/icons/Martech-SMEs.png";
import MarketingCloudStrategyAndRoadmapIcon from "../assets/images/icons/Marketing-Cloud-Strategy-And-Roadmap.png";
import ABTestingIcon from "../assets/images/icons/ABTesting.png";
import MultiChannelJourneyOrchestrationIcon from "../assets/images/icons/Multi-Channel-Journey-Orchestration.png";
import AdvancedSegmentationAndPersonalizationIcon from "../assets/images/icons/AdvancedSegmentationAndPersonalization.png";
import EinsteinGenerativeAIIcon from "../assets/images/icons/EinsteinGenerativeAI.png";

import serviceCloudBannerMobile from "../assets/images/banner/serviceCloudMobile.jpg";



const SalesServiceCloud = () => {
  return (
    <>
      <Helmet>
        <title>Salesforce Service Cloud Pune | AI Customer Support</title>

        <meta
          name="description"
          content="Enhance customer support with Salesforce Service Cloud. AI-powered service automation & CRM solutions in Pune, India."
        />

        <meta
          name="keywords"
          content="Service Cloud Pune, Salesforce CRM Support India, AI Customer Service Solutions"
        />

        <meta name="robots" content="index, follow" />
        <meta name="author" content="Comsense Technologies" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Salesforce Service Cloud Pune | AI Customer Support"
        />
        <meta
          property="og:description"
          content="AI-powered customer support & CRM solutions in Pune."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.comsensetechnologies.com/service-cloud"
        />
      </Helmet>

      <header className="masthead subPageHead data-cloud-header serviceCloudBanner">
        <div className="container">
          <Row className="justify-content-start">
            <Col xl={7} lg={5}>
              <h1 className="masthead-heading text-white mt-5 mb-5">
                Sales and{" "}
                <span className="fancy-text4 ps-1 pe-2 mb-0  z-0 text-EE0000  position-relative overflow-hiddens text-white">
                  {" "}
                  Service Cloud
                </span>{" "}
              </h1>
            </Col>
            <Col lg={12} className="mt-5 mt-lg-0 d-block d-lg-none">
              <Image className="w-100" src={serviceCloudBannerMobile} />
            </Col>
          </Row>
        </div>
      </header>

      <section className="bg-fff pt-80 pb-80">
        <Container>
          <Row className="align-items-center mb-3">
            <Col col={12}>
              <div className="text-center d-flex align-items-center justify-content-center">
                <h2 className="section-heading section-heading-center fw-700 fs-2">
                  Unifying revenue and service teams around <br></br>
                  <span className="bordered-text">
                    every customer moment
                  </span>{" "}
                </h2>
              </div>
            </Col>
          </Row>
          <Row className="mt-4 text-center justify-content-center">
            <Col lg={11} md={12} className="mb-2 mb-lg-0">
              <p className="mt-0 fs-5 fw-normal ls-0">
                At Comsense, we help organizations unlock the full potential of{" "}
                <span className="text-028bc6 fw-600">
                  Salesforce Sales & Service Cloud
                </span>{" "}
                with a data-first, AI-powered approach.
              </p>
              <p className="mt-0 fs-5 fw-normal ls-0">
                We bring sales, service, and operations onto a single, connected
                platform so your teams can see the same customer, act on the
                same insights, and move in the same direction—from first
                interaction to long-term loyalty.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="page-section pt-80 pb-80 bg-EFFDFF">
        <Container>
          <Row className="align-items-center mt-4 justify-content-center testimonials-area position-relative">
            <Col
              xl={2}
              lg={2}
              md={4}
              sm={6}
              xs={12}
              className="cus-col-sm text-center"
            >
              <div className="mb-5 mb-lg-0 bg-transparent shadow-none">
                <div className="position-relative">
                  <Image width={70} className="m-auto" src={MartechSMEsIcon} />
                </div>
                <h5 className="mb-1 mt-4 fw-800 fs-4">30+</h5>
                <p className="fw-500 fs-6">Sales & Service Cloud Experts</p>
              </div>
            </Col>
            <Col
              xl={2}
              lg={2}
              md={4}
              sm={6}
              xs={12}
              className="cus-col-sm text-center"
            >
              <div className="mb-5 mb-lg-0 bg-transparent shadow-none">
                <div className="position-relative">
                  <Image
                    width={70}
                    className="m-auto"
                    src={DataConsultantsIcon}
                  />
                </div>
                <h5 className="mb-1 mt-4 fw-800 fs-4">20+</h5>
                <p className="fw-500 fs-6">CRM & Process Consultants</p>
              </div>
            </Col>
            <Col
              xl={2}
              lg={2}
              md={4}
              sm={6}
              xs={12}
              className="cus-col-sm text-center"
            >
              <div className="mb-5 mb-lg-0 bg-transparent shadow-none">
                <div className="position-relative">
                  <Image
                    width={70}
                    className="m-auto"
                    src={inTheMartechIndustryIcon}
                  />
                </div>
                <h5 className="mb-1 mt-4 fw-800 fs-4">10+ Years</h5>
                <p className="fw-500 fs-6">in the Martech Industry</p>
              </div>
            </Col>
            <Col
              xl={2}
              lg={2}
              md={4}
              sm={6}
              xs={12}
              className="cus-col-sm text-center"
            >
              <div className="mb-5 mb-lg-0 bg-transparent shadow-none">
                <div className="position-relative">
                  <Image width={70} className="m-auto" src={expertsIcon} />
                </div>
                <h5 className="mb-1 mt-4 fw-800 fs-4">Multi Industry</h5>
                <p className="fw-500 fs-6">Sales & Service Experience</p>
              </div>
            </Col>
            <Col
              xl={2}
              lg={2}
              md={4}
              sm={6}
              xs={12}
              className="cus-col-sm text-center"
            >
              <div className="mb-5 mb-lg-0 bg-transparent shadow-none">
                <div className="position-relative">
                  <Image width={70} className="m-auto" src={topPartnersIcon} />
                </div>
                <h5 className="mb-1 mt-4 fw-800 fs-4">Top Partners</h5>
                <p className="fw-500 fs-6">of Salesforce</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="page-section  bg-fff pt-70 pb-70">
        <Container>
          <Row className="align-items-center mb-5">
            <Col col={11}>
              <div className="text-center">
                <h2 className="mb-4 section-heading section-heading-center fw-700 fs-2">
                  How we help you succeed with{" "}
                  <span className="bordered-text">
                    Salesforce Sales & Service Cloud
                  </span>
                </h2>
                <p className="text-252B42 ls-0 text-center fw-500 fs-20">
                  We architect <b>Sales Cloud</b> to fit the way your teams
                  actually sell—while embedding best practices, automation, and
                  analytics.
                </p>
              </div>
            </Col>
          </Row>
          <Row className="align-items-center mt-4 justify-content-start position-relative">
            <Col lg={12}>
              <Row>
                <Col lg={6} md={6}>
                  <div className="mb-4 mb-lg-4 d-flex align-items-center">
                    <div>
                      <div className="blue-gradient-sqr-icon text-center position-relative">
                        <Image
                          width={30}
                          className="m-auto"
                          src={MarketingCloudStrategyAndRoadmapIcon}
                        />
                      </div>
                    </div>
                    <div className="content ms-4 pe-3">
                      <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                        Lead & opportunity management
                      </h5>
                    </div>
                  </div>
                </Col>
                <Col lg={6} md={6}>
                  <div className="mb-4 mb-lg-4  d-flex align-items-center">
                    <div>
                      <div className="blue-gradient-sqr-icon text-center position-relative">
                        <Image
                          width={30}
                          className="m-auto"
                          src={ABTestingIcon}
                        />
                      </div>
                    </div>
                    <div className="content ms-4 pe-3">
                      <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                        Account & contact 360
                      </h5>
                    </div>
                  </div>
                </Col>
                <Col lg={6} md={6}>
                  <div className="mb-4 mb-lg-4  d-flex align-items-center">
                    <div>
                      <div className="blue-gradient-sqr-icon text-center position-relative">
                        <Image
                          width={30}
                          className="m-auto"
                          src={MultiChannelJourneyOrchestrationIcon}
                        />
                      </div>
                    </div>
                    <div className="content ms-4 pe-3">
                      <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                        Sales performance & forecasting
                      </h5>
                    </div>
                  </div>
                </Col>
                <Col lg={6} md={6}>
                  <div className="mb-4 mb-lg-4  d-flex align-items-center">
                    <div>
                      <div className="blue-gradient-sqr-icon text-center position-relative">
                        <Image
                          width={30}
                          className="m-auto"
                          src={AdvancedSegmentationAndPersonalizationIcon}
                        />
                      </div>
                    </div>
                    <div className="content ms-4 pe-3">
                      <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                        Territory & quota management
                      </h5>
                    </div>
                  </div>
                </Col>
                <Col lg={6} md={6}>
                  <div className="mb-4 mb-lg-4  d-flex align-items-center">
                    <div>
                      <div className="blue-gradient-sqr-icon text-center position-relative">
                        <Image
                          width={30}
                          className="m-auto"
                          src={EinsteinGenerativeAIIcon}
                        />
                      </div>
                    </div>
                    <div className="content ms-4 pe-3">
                      <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                        Revenue & deal execution (with Revenue Cloud / CPQ where
                        applicable)
                      </h5>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="page-section pt-0 pb-70 bg-white">
        <Container>
          <Row className="align-items-center mb-0">
            <Col col={11}>
              <div className="text-center d-flex align-items-center justify-content-center">
                <h2 className="text-252B42 ls-0 text-center fw-500 fs-20 mb-3">
                  We configure <b>Service Cloud</b> to make every interaction
                  faster, more informed, and more human—across all channels.
                </h2>
              </div>
            </Col>
          </Row>
          <Row className="align-items-center mt-4 justify-content-start position-relative">
            <Col lg={12}>
              <Row>
                <Col lg={6} md={6}>
                  <div className="mb-4 mb-lg-4 d-flex align-items-center">
                    <div>
                      <div className="blue-gradient-sqr-icon text-center position-relative">
                        <Image
                          width={30}
                          className="m-auto"
                          src={MarketingCloudStrategyAndRoadmapIcon}
                        />
                      </div>
                    </div>
                    <div className="content ms-4 pe-3">
                      <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                        Omnichannel case management
                      </h5>
                    </div>
                  </div>
                </Col>
                <Col lg={6} md={6}>
                  <div className="mb-4 mb-lg-4  d-flex align-items-center">
                    <div>
                      <div className="blue-gradient-sqr-icon text-center position-relative">
                        <Image
                          width={30}
                          className="m-auto"
                          src={ABTestingIcon}
                        />
                      </div>
                    </div>
                    <div className="content ms-4 pe-3">
                      <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                        Self-service & knowledge
                      </h5>
                    </div>
                  </div>
                </Col>
                <Col lg={6} md={6}>
                  <div className="mb-4 mb-lg-4  d-flex align-items-center">
                    <div>
                      <div className="blue-gradient-sqr-icon text-center position-relative">
                        <Image
                          width={30}
                          className="m-auto"
                          src={MultiChannelJourneyOrchestrationIcon}
                        />
                      </div>
                    </div>
                    <div className="content ms-4 pe-3">
                      <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                        Agent workspace & productivity
                      </h5>
                    </div>
                  </div>
                </Col>
                <Col lg={6} md={6}>
                  <div className="mb-4 mb-lg-4  d-flex align-items-center">
                    <div>
                      <div className="blue-gradient-sqr-icon text-center position-relative">
                        <Image
                          width={30}
                          className="m-auto"
                          src={AdvancedSegmentationAndPersonalizationIcon}
                        />
                      </div>
                    </div>
                    <div className="content ms-4 pe-3">
                      <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                        Field service (where relevant)
                      </h5>
                    </div>
                  </div>
                </Col>
                <Col lg={6} md={6}>
                  <div className="mb-4 mb-lg-4  d-flex align-items-center">
                    <div>
                      <div className="blue-gradient-sqr-icon text-center position-relative">
                        <Image
                          width={30}
                          className="m-auto"
                          src={EinsteinGenerativeAIIcon}
                        />
                      </div>
                    </div>
                    <div className="content ms-4 pe-3">
                      <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                        Service analytics & quality
                      </h5>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          {/* <Row className='align-items-center mt-3 justify-content-center position-relative'>
                        <Col lg={10}>
                            <Row className='justify-content-start'>
                                <Col lg={6} md={6}>
                                    <div className='mb-4 mb-lg-4 d-flex align-items-center'>
                                        <div>
                                            <div style={{ width: '50px', height: '50px', lineHeight: '45px' }} className='box-shadow-two text-center position-relative rounded-0'>
                                                <Image width={30} className='m-auto' src={IncreaseInQualifiedLeadIcon} />
                                            </div>
                                        </div>
                                        <div className='content ms-4 pe-3'>
                                            <h5 className='mb-2 fw-500 fs-5 ls-minus-05'>Omnichannel case management</h5>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={6} md={6}>
                                    <div className='mb-4 mb-lg-4 d-flex align-items-center'>
                                        <div>
                                            <div style={{ width: '50px', height: '50px', lineHeight: '45px' }} className='box-shadow-two text-center position-relative rounded-0'>
                                                <Image width={30} className='m-auto' src={ReductionInManualWorkIcon} />
                                            </div>
                                        </div>
                                        <div className='content ms-4 pe-3'>
                                            <h5 className='mb-2 fw-500 fs-5 ls-minus-05'>Self-service & knowledge</h5>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={6} md={6}>
                                    <div className='mb-4 mb-lg-4 d-flex align-items-center'>
                                        <div>
                                            <div style={{ width: '50px', height: '50px', lineHeight: '45px' }} className='box-shadow-two text-center position-relative rounded-0'>
                                                <Image width={30} className='m-auto' src={HigherConversionRatesIcon} />
                                            </div>
                                        </div>
                                        <div className='content ms-4 pe-3'>
                                            <h5 className='mb-2 fw-500 fs-5 ls-minus-05'>Agent workspace & productivity</h5>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={6} md={6}>
                                    <div className='mb-4 mb-lg-4 d-flex align-items-center'>
                                        <div>
                                            <div style={{ width: '50px', height: '50px', lineHeight: '45px' }} className='box-shadow-two text-center position-relative rounded-0'>
                                                <Image width={30} className='m-auto' src={ReportingOrROIMetricsIcon} />
                                            </div>
                                        </div>
                                        <div className='content ms-4 pe-3'>
                                            <h5 className='mb-2 fw-500 fs-5 ls-minus-05'>Field service (where relevant)</h5>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={6} md={6}>
                                    <div className='mb-4 mb-lg-4 d-flex align-items-center'>
                                        <div>
                                            <div style={{ width: '50px', height: '50px', lineHeight: '45px' }} className='box-shadow-two text-center position-relative rounded-0'>
                                                <Image width={30} className='m-auto' src={GreaterCustomerRetentionAndLoyaltyIcon} />
                                            </div>
                                        </div>
                                        <div className='content ms-4 pe-3'>
                                            <h5 className='mb-2 fw-500 fs-5 ls-minus-05'>Service analytics & quality</h5>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row> */}
        </Container>
      </section>

      <section className="page-section bg-EFFDFF pt-70 pb-70">
        <Container>
          <Row className="align-items-center mb-5">
            <Col lg={10} className="offset-lg-1">
              <div className="text-center">
                <span className="d-block fw-500 ls-0 mb-1 fs-15 text-252B42">
                  Every engagement follows a simple formula
                </span>
                <h2 className="section-heading text-center mb-0 section-heading-center fw-700 fs-40">
                  We listen. We plan. We execute.{" "}
                </h2>
                <p className="text-252B42 ls-0 fw-500 fs-20">
                  Whichever engagement you choose we align with your goals,
                  craft a clear roadmap, and get it done—while guiding you
                  strategically every step of the way
                </p>
              </div>
            </Col>
          </Row>

          <Row className="align-items-stretch mt-4 justify-content-center">
            <Col className="mb-3 d-flex" lg={3} md={6}>
              <div className="box-back rounded-1 z-0 w-100 d-flex flex-column">
                <div className="w8-bx-shadow z-1 bg-white w8-box position-relative rounded-1 ps-3 pe-3 pt-3 pb-4 d-flex flex-column flex-grow-1">
                  <h3 className="Fw-700 fs-16 fw-bold ls-0 mt-1">
                    Strategy & Solution Design
                  </h3>
                  <p className="text-left mb-0 ls-0 fw-400 fs-11 flex-grow-1">
                    We assess your sales and service operations, customer
                    journeys, and data flows to design a Salesforce solution
                    aligned to your revenue, service, and growth objectives.
                  </p>
                </div>
              </div>
            </Col>
            <Col className="mb-3 d-flex" lg={3} md={6}>
              <div className="blue-box-back rounded-1  z-0 w-100 d-flex flex-column">
                <div className="w8-bx-shadow z-1 bg-blue-gradient w8-box position-relative rounded-1 ps-3 pe-3 pt-3 pb-4 d-flex flex-column flex-grow-1">
                  <h3 className="Fw-700 fs-16 fw-bold ls-0 mt-1 text-white">
                    Sales & Service Cloud Implementation
                  </h3>
                  <p className="text-left mb-0 ls-0 text-white fw-400 fs-11 flex-grow-1">
                    Unify sales and support operations on a single Salesforce
                    platform with automated workflows, guided selling,
                    omnichannel case management, and real-time performance
                    visibility.
                  </p>
                </div>
              </div>
            </Col>
            <Col className="mb-3 d-flex" lg={3} md={6}>
              <div className="box-back rounded-1 z-0 w-100 d-flex flex-column">
                <div className="w8-bx-shadow z-1 bg-white w8-box position-relative rounded-1 ps-3 pe-3 pt-3 pb-4 d-flex flex-column flex-grow-1">
                  <h3 className="Fw-700 fs-16 fw-bold ls-0 mt-1">
                    Managed Services & Optimization
                  </h3>
                  <p className="text-left mb-0 ls-0 fw-400 fs-11 flex-grow-1">
                    Ensure continuous performance with proactive monitoring,
                    enhancements, release management, and ongoing optimization
                    of your Sales & Service Cloud environment.
                  </p>
                </div>
              </div>
            </Col>
            <Col className="mb-3 d-flex" lg={3} md={6}>
              <div className="blue-box-back rounded-1  z-0 w-100 d-flex flex-column">
                <div className="w8-bx-shadow z-1 bg-blue-gradient w8-box position-relative rounded-1 ps-3 pe-3 pt-3 pb-4 d-flex flex-column flex-grow-1">
                  <h3 className="Fw-700 fs-16 fw-bold ls-0 mt-1 text-white">
                    Audit & Performance Assessment
                  </h3>
                  <p className="text-left mb-0 ls-0 text-white fw-400 fs-11 flex-grow-1">
                    Evaluate your existing Salesforce setup to identify gaps in
                    process efficiency, data quality, user adoption, and
                    automation—backed by actionable improvement recommendations.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="page-section  bg-white pt-70 pb-70">
        <Container>
          <Row className="align-items-center mb-5">
            <Col col={11}>
              <div className="text-center">
                <h2 className="section-heading section-heading-center fw-700 fs-2">
                  Why Comsense for Sales & Service{" "}
                  <span className="bordered-text">Cloud</span>
                </h2>
              </div>
            </Col>
          </Row>
          <Row className="align-items-center mt-4 justify-content-start position-relative">
            <Col lg={12}>
              <Row>
                <Col lg={6} md={6}>
                  <div className="mb-4 mb-lg-4 d-flex align-items-center">
                    <div>
                      <div className="blue-gradient-sqr-icon text-center position-relative">
                        <Image
                          width={30}
                          className="m-auto"
                          src={MarketingCloudStrategyAndRoadmapIcon}
                        />
                      </div>
                    </div>
                    <div className="content ms-4 pe-3">
                      <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                        Data-to-action DNA
                      </h5>
                      <p className="fw-500 fs-6 mb-0 ls-minus-02 text-2C354CB2">
                        We bring deep Salesforce Data & AI expertise to ensure
                        Sales & Service Cloud is not just a system of record,
                        but a system of intelligence.
                      </p>
                    </div>
                  </div>
                </Col>
                <Col lg={6} md={6}>
                  <div className="mb-4 mb-lg-4  d-flex align-items-center">
                    <div>
                      <div className="blue-gradient-sqr-icon text-center position-relative">
                        <Image
                          width={30}
                          className="m-auto"
                          src={ABTestingIcon}
                        />
                      </div>
                    </div>
                    <div className="content ms-4 pe-3">
                      <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                        Certified multi-cloud Salesforce experts
                      </h5>
                      <p className="fw-500 fs-6 mb-0 ls-minus-02 text-2C354CB2">
                        Our team has hands-on experience across Sales, Service,
                        Marketing, and Data Cloud, enabling truly connected
                        customer journeys.
                      </p>
                    </div>
                  </div>
                </Col>
                <Col lg={6} md={6}>
                  <div className="mb-4 mb-lg-4  d-flex align-items-center">
                    <div>
                      <div className="blue-gradient-sqr-icon text-center position-relative">
                        <Image
                          width={30}
                          className="m-auto"
                          src={MultiChannelJourneyOrchestrationIcon}
                        />
                      </div>
                    </div>
                    <div className="content ms-4 pe-3">
                      <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                        Industry-aware delivery
                      </h5>
                      <p className="fw-500 fs-6 mb-0 ls-minus-02 text-2C354CB2">
                        We apply proven patterns from industries such as Retail,
                        Automotive, Financial Services, Non-profits, and
                        more—while respecting your unique context.
                      </p>
                    </div>
                  </div>
                </Col>
                <Col lg={6} md={6}>
                  <div className="mb-4 mb-lg-4  d-flex align-items-center">
                    <div>
                      <div className="blue-gradient-sqr-icon text-center position-relative">
                        <Image
                          width={30}
                          className="m-auto"
                          src={AdvancedSegmentationAndPersonalizationIcon}
                        />
                      </div>
                    </div>
                    <div className="content ms-4 pe-3">
                      <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                        End-to-end partnership
                      </h5>
                      <p className="fw-500 fs-6 mb-0 ls-minus-02 text-2C354CB2">
                        From strategy and architecture through implementation
                        and managed services, we stay accountable for outcomes,
                        not just go-lives.
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="page-section z-0 bg-E2F1FE overflow-hidden pt-70 pb-70 position-relative">
        <Image
          className="position-absolute z-n1 w-250 bg-cover h-auto position-absolute start-0 bottom-0"
          src={layerOne}
        />
        <Container>
          <Row className="align-items-center justify-content-center">
            <Col lg={7}>
              <div className="text-center">
                <h2
                  className="text-252B42 fw-700 fs-26"
                  style={{ lineHeight: "normal" }}
                >
                  Ready to connect sales and service around your customer?
                </h2>
                <p className="ls-minus036 fs-13">
                  Connect with our team to explore how Salesforce Sales &
                  Service Cloud, implemented and optimized by Comsense, can help
                  you build predictable growth and differentiated customer
                  experiences.
                </p>
                <Nav.Link
                  className="d-inline-block  text-white btn btn-danger btn-xl me-3 ls-0 fw-600"
                  as={Link}
                  to="../contact"
                >
                  Talk to our Expert
                </Nav.Link>
              </div>
            </Col>
          </Row>
        </Container>
        <Image
          className="position-absolute w-250 z-n1 bg-cover h-auto position-absolute end-0 top-0 opacity-25"
          src={layerTwo}
        />
      </section>
    </>
  );
};

export default SalesServiceCloud;
